import type { IUserInfo } from "@/account/account-models";
import { Avatar } from "@/common/avatar";
import { EAvatarType } from "@/common/avatar/avatar-helpers";
import { ICONS_ACCOUNT } from "@/common/icons/icons-account";
import { NumberHighlight } from "@/common/number-highlight";
import { ENumberHighlightType } from "@/common/number-highlight/number-highlight-models";
import { DEFAULT_IMAGE_SRC } from "@/utils/images";
import { numberToHumanReadable } from "@/utils/string";
import React from "react";
import lockIcon from "./assets/lock.svg";

export const GetCreditsSubscriptionHeader = React.memo(
  function GetCreditsSubscriptionHeader(props: { affiliate: IUserInfo }) {
    return (
      <div className="mb-4">
        <div
          className="relative -mt-header-height -mr-5 mb-4.5 -ml-5 flex items-center gap-4 overflow-hidden rounded-t-3xl bg-media-placeholder pt-4 pr-5 pb-4 pl-5 *:relative *:z-1 before:absolute before:-inset-2.5 before:scale-105 before:bg-(image:--header-bg) before:bg-cover before:bg-center before:blur before:content-[''] after:absolute after:inset-0 after:bg-[rgba(0,0,0,0.45)] after:content-['']"
          style={{
            ["--header-bg" as string]: `url(${props.affiliate.avatar?.th || DEFAULT_IMAGE_SRC})`,
          }}
        >
          <Avatar
            avatar={props.affiliate.avatar}
            type={EAvatarType.SubscribePopup}
          />
          <div className="flex flex-wrap">
            <NumberHighlight
              type={ENumberHighlightType.Top}
              number={numberToHumanReadable(props.affiliate.image_count || 0)}
              color="white"
              inlineStyle={{
                width: "50%",
                padding: 5,
              }}
            >
              PHOTOS
            </NumberHighlight>
            <NumberHighlight
              type={ENumberHighlightType.Top}
              number={numberToHumanReadable(props.affiliate.video_count || 0)}
              color="white"
              inlineStyle={{
                width: "50%",
                padding: 5,
              }}
            >
              VIDEOS
            </NumberHighlight>
            <NumberHighlight
              type={ENumberHighlightType.Top}
              number={"ALL"}
              color="white"
              inlineStyle={{
                width: "50%",
                padding: 5,
              }}
            >
              NEW POSTS
            </NumberHighlight>
            {props.affiliate.subscription_free_chats ? (
              <NumberHighlight
                type={ENumberHighlightType.Top}
                number={"CHAT"}
                color="white"
                inlineStyle={{
                  width: "50%",
                  padding: 5,
                }}
              >
                INCLUDED
              </NumberHighlight>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "50%",
                  padding: 5,
                }}
              >
                <img src={lockIcon} alt="" width={24} height={30} />
              </div>
            )}
          </div>
        </div>
        <h2 className="mb-3 text-heading font-bold text-body-text">
          Unlock {props.affiliate.display_name || props.affiliate.username}’s
          exclusive content
        </h2>
        <div className="mb-1">
          <div className="mb-1 flex">
            <div className="pt-0.75 pr-2 pb-0 pl-0">{ICONS_ACCOUNT.Tick}</div>
            <div className="text-left text-body-lg font-normal text-body-text">
              Instant access to exclusive photos & videos
            </div>
          </div>
          <div className="mb-1 flex">
            <div className="pt-0.75 pr-2 pb-0 pl-0">{ICONS_ACCOUNT.Tick}</div>
            <div className="text-left text-body-lg font-normal text-body-text">
              Be the first to see new posts
            </div>
          </div>
          {props.affiliate.subscription_free_chats ? (
            <div className="mb-1 flex">
              <div className="pt-0.75 pr-2 pb-0 pl-0">{ICONS_ACCOUNT.Tick}</div>
              <div className="text-left text-body-lg font-normal text-body-text">
                FREE chat included for subscribers
              </div>
            </div>
          ) : (
            <div className="mb-1 flex">
              <div className="pt-0.75 pr-2 pb-0 pl-0">{ICONS_ACCOUNT.Tick}</div>
              <div className="text-left text-body-lg font-normal text-body-text">
                Get priority attention in chats
              </div>
            </div>
          )}
        </div>
        <hr className="my-4.5 border-t border-t-border-light" />
      </div>
    );
  }
);
